/* eslint-disable vue/no-parsing-error */ /* eslint-disable vue/no-parsing-error */
<template>
  <div class="uploadGuide">
    <div class="guide-header">
      <p class="guide-header-title">主要指引步骤包括：</p>
      <p class="guide-header-content">1、申请退款/退货卖家不同意怎么办？</p>
      <p class="guide-header-content">2、作为买家未收到货，订单被平台冻结怎么办？</p>
    </div>
    <section>
      <div class="guide-title">一、申请退款/退货卖家不同意</div>
      <section>
        <div class="guide-title-two">1、申请退款/退货卖家拖着不处理</div>
        <div class="guide-list">
          ①卖家未发货：如卖家不对退款申请进行操作，从买家申请起2天后系统将自动确认退款，钱款打回至买家账户。
        </div>
        <div class="guide-list">②卖家已发货：如卖家在7天内未处理，系统将自动给买家退款。</div>
        <div class="guide-digest">•说明：系统自动确认时间均以退款信息内倒计时时间为准</div>
      </section>
      <section>
        <div class="guide-title-two ">2、卖家拒绝退款申请怎么办？</div>
        <div class="guide-content">
          在对应的订单详情页中进入【查看退款详情】，点击右下方【申请平台介入】，双方在规定时间内提交维权凭证，客服将根据凭证进行仲裁，决定钱款最终走向。
        </div>
        <img
          class="guide-img"
          :src="setPicSize('n_v2e7fdc285e5714e41bfb4a4adace7de18.png')"
          @click="showBig(0)"
          width="100%"
          alt="加载中..."
        />
      </section>
    </section>

    <section>
      <div class="guide-title">二、作为买家未收到货物，订单被平台冻结</div>
      <div class="guide-red">请尽快到【我的】-【客服中心】寻求人工客服帮助！</div>
      <div class="guide-content">
        订单冻结期间，钱款会在平台内；一旦超出冻结时间，钱款将自动打给卖家！届时如未收到货物，损失无法追回！请及时寻求人工客服帮助！
      </div>
    </section>
  </div>
</template>

<script>
import { ImagePreview } from '@zz-common/zz-ui'
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
// import { lego } from '@zz-common/lego'
// import { toast } from '../../../native'
import { queryParams } from '../../../lib/utils'

const query = queryParams()

export default {
  name: 'uploadExample',
  data() {
    return {
      from: query.from || this.$route.query.from, //  用户页面是2，商品页面是1，短视频页面是7，私信文字页面是4
      reasonId: query.reasonId || this.$route.query.reasonId,
      beReportedUid: query.bereporteduid || this.$route.query.bereporteduid,
      infoId: query.infoid || this.$route.query.infoid,
      videoId: query.videoId || this.$route.query.videoId,
      imgList: ['https://pic1.zhuanstatic.com/zhuanzh/n_v2e7fdc285e5714e41bfb4a4adace7de18.png']
    }
  },
  // components: { Col, Row },
  computed: {},
  methods: {
    setPicSize,
    showBig(startPosition) {
      ImagePreview({
        images: this.imgList,
        startPosition,
        adaptApp: true
      })
    },
    closePage() {
      native.close()
    }
  },
  mounted() {
    native.setTitle({
      title: '步骤指引'
    })
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  },
  beforeRouteUpdate(to, _from, _next) {
    this.reasonId = to.query.reasonId
  }
}
</script>

<style scoped lang="less">
  @import 'uploadGuide.less';
</style>
